import _ from 'lodash'

import i18n from '@/i18n/i18n'
import { TarfinProProductPriceService } from '@/services/admin/TarfinProProductPriceService'

import { errorMessage } from '@/utilities/helpers.js'

import { TARFIN_PRO_PRODUCT_PRICE_ERROR_MESSAGES } from '@/constants/errorMessages'

const { t } = i18n.global

export const namespaced = true

export const state = {
  addedProducts: null,
  marketInfo: null
}

export const mutations = {
  SET_ADDED_PRODUCTS(state, products) {
    state.addedProducts = products
  },
  SET_MARKET_INFO(state, marketInfo) {
    state.marketInfo = marketInfo
  }
}

export const actions = {
  getProducts({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      TarfinProProductPriceService.getProducts()
        .then(response => {
          commit('SET_ADDED_PRODUCTS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: TARFIN_PRO_PRODUCT_PRICE_ERROR_MESSAGES.getPricesError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updatePrices({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      let prices = _.sortBy(params, product => {
        return product.price
      })
      TarfinProProductPriceService.updatePrices({ prices: prices.reverse() })
        .then(response => {
          commit('SET_ADDED_PRODUCTS', response.data)
          const notification = {
            type: 'success',
            message: t('store.retailer.price.prices_saved')
          }
          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: TARFIN_PRO_PRODUCT_PRICE_ERROR_MESSAGES.savePricesError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })

          reject(err)
        })
    })
  },
  createNewTarfinProProductPrice({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      TarfinProProductPriceService.createPrice(params.product)
        .then(response => {
          commit('SET_ADDED_PRODUCTS', response.data)
          const notification = {
            type: 'success',
            message: t('store.retailer.price.prices_saved')
          }
          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: TARFIN_PRO_PRODUCT_PRICE_ERROR_MESSAGES.savePricesError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })

          reject(err)
        })
    })
  },
  deleteTarfinProProductPrice({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      TarfinProProductPriceService.deletePrice(id)
        .then(response => {
          commit('SET_ADDED_PRODUCTS', response.data)
          const notification = {
            type: 'success',
            message: t('store.admin.tarfin_pro_product_price.delete_success_message')
          }
          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: TARFIN_PRO_PRODUCT_PRICE_ERROR_MESSAGES.deletePriceError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  changeTarfinProProductPriceMarketStatus({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      TarfinProProductPriceService.changeMarketStatus(params)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.tarfin_pro_product_price.market_status_updated')
          }
          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: TARFIN_PRO_PRODUCT_PRICE_ERROR_MESSAGES.marketStatusChangeError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })

          reject(err)
        })
    })
  },
  getMarketInfo({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      TarfinProProductPriceService.getMarketInfo()
        .then(response => {
          commit('SET_MARKET_INFO', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: TARFIN_PRO_PRODUCT_PRICE_ERROR_MESSAGES.getMarketStatusError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
